import { cocktailConstants } from '../_constants';
import { cocktailService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const cocktailActions = {
  addIngredient,
  addRecipe,
  updateIngredient,
  getAllIngredients,
  getAllRecipes,
  getMyRecipes,
  getIngredientById,
  getRecipeImage,
  deleteIngredient,
  deleteRecipe,
  updateCocktailCounts,
  addRemoveFavoritesCollection,
  updateFavoritesCounts
};

function addIngredient(ingredient, update) {
  return dispatch => {
    dispatch(request(ingredient));

    console.log("Does this include the strange container?: ", ingredient);
    cocktailService.addIngredient(ingredient)
      .then(
        ingredient => {
      dispatch(success(ingredient));
    history.push('/ingredient');
    dispatch(alertActions.success(ingredient.name + ( update ? ' updated' : ' added' ) + ' successfully!'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(ingredient) { return { type: cocktailConstants.CONTRIBUTE_REQUEST, ingredient } }
  function success(ingredient) { return { type: cocktailConstants.CONTRIBUTE_SUCCESS, ingredient } }
  function failure(error) { return { type: cocktailConstants.CONTRIBUTE_FAILURE, error } }
}

function addRecipe(recipe, update) {
  return dispatch => {
    dispatch(request(recipe));

    cocktailService.addRecipe(recipe)
      .then(
        recipe => {
      dispatch(success(recipe));
    history.push('/recipe');
    dispatch(alertActions.success(recipe.name + ( update ? ' updated' : ' added' ) + ' successfully!'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(recipe) { return { type: cocktailConstants.CONTRIBUTE_REQUEST, recipe } }
  function success(recipe) { return { type: cocktailConstants.CONTRIBUTE_SUCCESS, recipe } }
  function failure(error) { return { type: cocktailConstants.CONTRIBUTE_FAILURE, error } }
}

function updateIngredient(ingredient) {

  return dispatch => {
    dispatch(request(ingredient));

    cocktailService.update(ingredient)
      .then(
        ingredient => {
      dispatch(success(ingredient));
    history.push('/ingredient');
    dispatch(alertActions.success('Profile save successful'));
  },
    error => {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  );
  };

  function request(ingredient) { return { type: cocktailConstants.LOGIN_REQUEST, ingredient } }
  function success(ingredient) { return { type: cocktailConstants.LOGIN_SUCCESS, ingredient } }
  function failure(error) { return { type: cocktailConstants.LOGIN_FAILURE, error } }
}

function getAllIngredients() {
  return dispatch => {
    dispatch(request());
    cocktailService.getAllIngredients()
      .then(
        ingredients => dispatch(success(ingredients)),
      error => dispatch(failure(error))
  );
  };

  function request() { return { type: cocktailConstants.GETALLINGREDIENTS_REQUEST } }
  function success(ingredients) { return { type: cocktailConstants.GETALLINGREDIENTS_SUCCESS, ingredients } }
  function failure(error) { return { type: cocktailConstants.GETALLINGREDIENTS_FAILURE, error } }
}

function getAllRecipes() {
  return dispatch => {
    dispatch(request());
    cocktailService.getAllRecipes()
      .then(
        recipes => dispatch(success(recipes)),
      error => dispatch(failure(error))
  );
  };

  function request() { return { type: cocktailConstants.GETALLRECIPES_REQUEST } }
  function success(recipes) { return { type: cocktailConstants.GETALLRECIPES_SUCCESS, recipes } }
  function failure(error) { return { type: cocktailConstants.GETALLRECIPES_FAILURE, error } }
}

function getMyRecipes(cabinet, keyIngredients) {
  return dispatch => {
    dispatch(request());
    cocktailService.getMyRecipes(cabinet, keyIngredients)
      .then(
        my_recipes => dispatch(success(my_recipes)),
      error => dispatch(failure(error))
  );
  };

  function request() { return { type: cocktailConstants.GETMYRECIPES_REQUEST } }
  function success(my_recipes) { return { type: cocktailConstants.GETMYRECIPES_SUCCESS, my_recipes } }
  function failure(error) { return { type: cocktailConstants.GETMYRECIPES_FAILURE, error } }
}

function getIngredientById(_id) {
  return dispatch => {
    dispatch(request(_id));

    cocktailService.getIngredientById(_id)
      .then(
        ingredient => dispatch(success(ingredient)),
      error => dispatch(failure(error))
  );
  };

  function request(machine_name) { return { type: cocktailConstants.GETINGREDIENTBYID_REQUEST, machine_name } }
  function success(machine_name) { return { type: cocktailConstants.GETINGREDIENTBYID_SUCCESS, machine_name } }
  function failure(error) { return { type: cocktailConstants.GETINGREDIENTBYID_FAILURE, error } }
}

function getRecipeImage(_id) {
  return dispatch => {
    dispatch(request(_id));

    cocktailService.getRecipeImage(_id)
      .then(
        recipe_image => dispatch(success(_id, recipe_image)),
      error => dispatch(failure(error))
  );
  };

  function request(_id) { return { type: cocktailConstants.GETRECIPEIMAGEBYID_REQUEST, _id } }
  function success(_id, recipe_image) { return { type: cocktailConstants.GETRECIPEIMAGEBYID_SUCCESS, _id, recipe_image } }
  function failure(error) { return { type: cocktailConstants.GETRECIPEIMAGEBYID_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function deleteIngredient(_id) {
  return dispatch => {
    dispatch(request(_id));

    cocktailService.deleteIngredient(_id)
      .then(
        user => {
      dispatch(success(_id));
  },
    error => {
      dispatch(failure(_id, error));
    }
  );
  };

  function request(_id) { return { type: cocktailConstants.DELETEINGREDIENT_REQUEST, _id } }
  function success(_id) { console.log("Deleted successfully.  ID:", _id); return { type: cocktailConstants.DELETEINGREDIENT_SUCCESS, _id } }
  function failure(_id, error) { return { type: cocktailConstants.DELETEINGREDIENT_FAILURE, _id, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function deleteRecipe(_id) {
  return dispatch => {
    dispatch(request(_id));

    cocktailService.deleteRecipe(_id)
      .then(
        user => {
      dispatch(success(_id));
  },
    error => {
      dispatch(failure(_id, error));
    }
  );
  };

  function request(_id) { return { type: cocktailConstants.DELETERECIPE_REQUEST, _id } }
  function success(_id) { console.log("Deleted successfully.  ID:", _id); return { type: cocktailConstants.DELETERECIPE_SUCCESS, _id } }
  function failure(_id, error) { return { type: cocktailConstants.DELETERECIPE_FAILURE, _id, error } }
}

function addRemoveFavoritesCollection(email, machine_name, add = true) {
  return dispatch => {
    dispatch(request());

    cocktailService.addRemoveFavoritesCollection(email, machine_name, add)
      .then(
        cocktail => {
      dispatch(success());
  },
    error => {
      dispatch(failure(error));
    }
  );
  };

  function request() { return { type: cocktailConstants.ADDREMOVEFAVORITES_REQUEST } }
  function success() { return { type: cocktailConstants.ADDREMOVEFAVORITES_SUCCESS } }
  function failure(error) { return { type: cocktailConstants.ADDREMOVEFAVORITES_FAILURE, error } }
}

function updateCocktailCounts() {
  return dispatch => {
    dispatch(request());

    cocktailService.updateCocktailCounts()
      .then(
        ingredient => {
      dispatch(success());
  },
    error => {
      dispatch(failure(error));
    }
  );
  };

  function request() { return { type: cocktailConstants.UPDATECOCKTAILCT_REQUEST } }
  function success() { console.log("Updated Cocktail Ct successfully."); return { type: cocktailConstants.UPDATECOCKTAILCT_SUCCESS } }
  function failure(error) { return { type: cocktailConstants.UPDATECOCKTAILCT_FAILURE, error } }
}

function updateFavoritesCounts() {
  return dispatch => {
    dispatch(request());

    cocktailService.updateFavoritesCounts()
      .then(
        recipe => {
      dispatch(success());
  },
    error => {
      dispatch(failure(error));
    }
  );
  };

  function request() { return { type: cocktailConstants.UPDATEFAVORITESCT_REQUEST } }
  function success() { console.log("Updated Favorites Ct successfully."); return { type: cocktailConstants.UPDATEFAVORITESCT_SUCCESS } }
  function failure(error) { return { type: cocktailConstants.UPDATEFAVORITESCT_FAILURE, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/cocktail.actions.js